import { render, staticRenderFns } from "./ShopDiamond.vue?vue&type=template&id=ce353c00&scoped=true&"
import script from "./ShopDiamond.vue?vue&type=script&lang=js&"
export * from "./ShopDiamond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce353c00",
  null
  
)

export default component.exports